/**
 * Pomocnicze funkcji formularzy Utrzymania i usług: kwoty wpisywane po polsku („1 990,50 zł”),
 * godziny puli, mapowanie błędów walidacji na pola.
 */

/** „1 990,50 zł” → "1990.50"; pusty tekst → null; niepoprawny → undefined. */
export function parseAmountInput(raw: string): string | null | undefined {
  const text = raw
    .replace(/zł|pln/gi, '')
    .replace(/[\s ]/g, '')
    .replace(',', '.');
  if (!text) return null;
  if (!/^\d{1,10}(\.\d{1,2})?$/.test(text)) return undefined;
  return text;
}

/** "1990.00" → "1990", "1990.50" → "1990,50" (wartość pola formularza). */
export function amountInputValue(amount: string | null | undefined): string {
  if (!amount) return '';
  const [int, frac = ''] = amount.split('.');
  return /^0*$/.test(frac) ? (int ?? '') : `${int},${frac.padEnd(2, '0')}`;
}

/** Pula godzin: „40”, „12,5” → sekundy; pusty → null; niepoprawny → undefined. */
export function parseHoursInput(raw: string): number | null | undefined {
  const text = raw.trim().replace(',', '.');
  if (!text) return null;
  const n = Number(text);
  if (!Number.isFinite(n) || n <= 0) return undefined;
  return Math.round(n * 3600);
}

export function hoursInputValue(seconds: number | null | undefined): string {
  if (!seconds) return '';
  const h = seconds / 3600;
  return Number.isInteger(h) ? String(h) : String(Math.round(h * 100) / 100).replace('.', ',');
}

/** Pierwszy błąd dla każdego pola (ścieżka `contract.price` → pole `contract.price`, potem `contract`). */
export function issuesToErrors<K extends string>(
  issues: Array<{ path: string; message: string }>,
  keys: readonly K[],
): Partial<Record<K, string>> {
  const out: Partial<Record<K, string>> = {};
  for (const issue of issues) {
    const exact = keys.find((k) => k === issue.path);
    const top = keys.find((k) => k === issue.path.split('.')[0]);
    const key = exact ?? top;
    if (key && !out[key]) out[key] = issue.message;
  }
  return out;
}

export function zodIssues(error: { issues: Array<{ path: (string | number)[]; message: string }> }) {
  return error.issues.map((i) => ({ path: i.path.join('.'), message: i.message }));
}
